import React, { useState } from 'react';
import { type UpdateReferenceOptions } from './ReferenceAhaPill';
import { setLocalStorageJSONPreference } from 'javascripts/utils';
import styles from '../../../Reference.module.css';
import { type AhaReferenceElement } from '@aha-app/aha-editor-v2';
import { defaultFields, fieldsForItem } from './pillFields';
import { prefKeyForItemClass } from '../utils';

export const ReferenceAhaContextMenu = ({
  element,
  onUpdateReferenceOptions,
}: {
  element: AhaReferenceElement;
  onUpdateReferenceOptions: UpdateReferenceOptions;
}) => {
  const [selectedOptions, setSelectedOptions] = useState(
    element.reference_visibleFields || defaultFields(element.reference_class)
  );
  const options = fieldsForItem(element.reference_class);

  const updateSelectedOptions = option => {
    const newSelectedOptions = selectedOptions.slice();
    if (newSelectedOptions.includes(option.key)) {
      const index = newSelectedOptions.indexOf(option.key);
      newSelectedOptions.splice(index, 1);
    } else {
      newSelectedOptions.push(option.key);
    }

    if (newSelectedOptions.length === 0) {
      // Don't allow all fields to be removed
      return;
    }

    setSelectedOptions(newSelectedOptions);
    onUpdateReferenceOptions({
      visibleFields: newSelectedOptions,
    });
    setLocalStorageJSONPreference(
      prefKeyForItemClass(element.reference_class),
      newSelectedOptions
    );
  };

  return (
    <aha-menu-group label='Show record details'>
      {options.map(option => {
        const selected = selectedOptions.includes(option.key);
        const disabled = selected && selectedOptions.length === 1;

        return (
          <aha-menu-item key={option.key}>
            <label className={styles.menuitem}>
              <input
                type='checkbox'
                checked={selected}
                onChange={() => updateSelectedOptions(option)}
                name={`ReferenceAhaContextMenu_${option.key}`}
                disabled={disabled}
              />
              {option.title}
            </label>
          </aha-menu-item>
        );
      })}
    </aha-menu-group>
  );
};
